import React from 'react';

import LloydContainer from "../../lloyd/container/LloydContainer";
import UniversalItemList from "../StandardItems/UniversalItemList";
import ClusteredItemList from "../ClusteredItems/main/ClusteredItemList";
import StandardItemList from "../StandardItems/StandardItemList";
import {parsePageType} from "../../logic/productGroup";

// 2026 props:   groupId productGroup groupProperties
// shoppingCart dynamicCart customerVehicle vehicleContext clusterIndex
// itemApplications allApps products productDetail dispatch
export default function GroupProductsUi({ ...props}) {
  const { productGroup } = props;

  if (!productGroup?.id)
    return null;

  // 2025-06 - properties are camelCased, but lower in the structure snake_case shit remains.
  // Lloyd uses the snake_case shit heavily.
  let pt = parsePageType(productGroup?.pageType);

  if (pt.lloyd) {
    const {productDetail = {}} = props;
    // Expand children of productDetail
    return <LloydContainer {...props} {...productDetail} />
  } else if (pt.clustered) {
    return <ClusteredItemList {...props} />
  } else if (pt.universal) {
    return <UniversalItemList {...props} />
  } else {
    // STANDARD - non-clustered, non-universal.
    // https://lisa.aagarage.net/Tonneau-Covers/BakFlip-MX4-Tonneau-Cover
    return <StandardItemList {...props} />
  }
}
